













































/* eslint-disable */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';
import { User } from '@/libs/api.interfaces';
import { mapState } from 'vuex';

import Checkbox from '@/components/Checkbox.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import { AxiosError } from 'axios';
interface ReportParams {
  datasearch: String;
}
@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    Checkbox,
    ActionPopup,
  },
  computed: mapState(['user']),
  methods: {
    format,
  },
})
export default class BacthInvoice extends Vue {
  user!: {
    user: User;
  };
  loading = true;
  listDataBacthInvoice: any[] = [];
  params: ReportParams = {} as ReportParams;
  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;
  openDetail(id: number) {
    this.$router.push(`/easyinvoice/Einvoice/invoicebatchdetail/${id}`);
  }
  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString()},
    });
  }

  async getBatchInvoice(parameters: ReportParams, page = 1) {
    this.params = parameters;
    try {
      this.loading = true;
      const search = this.params.datasearch.length === 0 ? undefined : this.params.datasearch;
      const { data } = await api.post('/easyinvoice/invoices_list_batch', {
        /* eslint-disable-next-line @typescript-eslint/camelcase */
          page,
          user_group: 5,
          merch_id: this.user.user.merchant_id,
          status: search,
      });
      // console.log(data);
      if (data.data) {
          this.page = page;
          this.listDataBacthInvoice = data.data.data;
          this.totalPage = data.per_page;
          this.from = 10 * data.current_page - 9;
          this.to = 10 * data.current_page;
          this.totalItem = 10 * data.per_page;
          this.loading = false;
      }
      return null;
    } catch (err) {
      // console.log(err);
      // showToast(ToastType.FAILED, 'Oops… Sorry', err.response.data.error.errors[0].message);
      this.loading = false;
      return err as AxiosError;
    }
  }
}
